module.exports = __webpack_public_path__ + "img/bg_image_6.b959b8df.png";